import { API } from './api'
import { makeGetRequest } from './fetchCalls'
import axiosServerV1 from './serverHandler'

async function getTeamList() {
  return await makeGetRequest(API.TEAM.GET_TEAM_LIST)
}

async function teamUserDelete(userId) {
  return await axiosServerV1.delete(API.TEAM.TEAM_USER_ID(userId))
}

async function teamUserEdit(userId, userData) {
  const res = await axiosServerV1.patch(API.TEAM.TEAM_USER_ID(userId), userData)
  return res?.data ?? {}
}

async function teamUserRemind(email) {
  try {
    const res = await axiosServerV1.post(API.TEAM.TEAM_USER_REMIND, { email })
    return res?.data ?? {}
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ?? 'Error sending reminder'
    throw new Error(errorMessage)
  }
}

export async function getPublicTeamConfig(teamId) {
  return await makeGetRequest(API.TEAM.PUBLIC_TEAM_CONFIG_ID(teamId))
}

export const API_TEAM = {
  getTeamList,
  teamUserDelete,
  teamUserEdit,
  teamUserRemind,
  getPublicTeamConfig,
}
